import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DSSProcessingLogStatus, ImportProtocolLogEntryDTO } from 'src/app/base/models/models.swagger.generated';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { TooltipHelper } from 'src/app/base/shared/tooltip-helper';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';

@Component({
    selector: 'app-import-configuration-protocol-edit-form-log-list',
    templateUrl: './import-configuration-protocol-edit-form-log-list.component.html',
    styleUrls: ['./import-configuration-protocol-edit-form-log-list.component.scss'],
    imports: [GridModule, TranslateModule, TooltipModule]
})
export class ImportConfigurationProtocolEditFormLogListComponent {

  @Input()
  public set logEntries(value: ImportProtocolLogEntryDTO[]) {
    if (value != this._logEntries) {
      this._logEntries = value;
      this.cdr.detectChanges();
      // TODO: refresh
    }
  }

  @Input()
  public iteration: number;

  @Output() public iterationChanged: EventEmitter<number> = new EventEmitter<number>();

  public get logEntries(): ImportProtocolLogEntryDTO[] {
    return this._logEntries;
  }

  public get iterations(): number[] {
    return Array.from({ length: this.iteration + 1 }, (v, k) => k).reverse();
  }

  public filterSettings = GridConstantsFactory.createStandardFilterSettings();
  public successStateFilter = GridConstantsFactory.createCheckBoxFilter();
  public lineNumberFilter = GridConstantsFactory.createCheckBoxFilter();
  public LogStatus = DSSProcessingLogStatus;

  private _logEntries: ImportProtocolLogEntryDTO[];

  constructor(private cdr: ChangeDetectorRef) { }

  public getState(data: ImportProtocolLogEntryDTO): string {
    return 'i18n.domain.import-configuration.enums.success-state.' + DSSProcessingLogStatus[data.logStatus];
  }

  //try to extract json content from the message.
  public extractJsonMessage(data: string, onlyContent: boolean, maxChar: number): string {
    return TooltipHelper.extractJsonMessage(data, onlyContent, maxChar);
  }

  public onIterationChanged(selectedIteration: string) {
    const selectedIt = selectedIteration ? +selectedIteration : null;
    this.iterationChanged.emit(selectedIt);
  }
}
